/** Typography scale from Kintsugi Design System Styleguide. */
export const typographyScale = {
  h1: {
    bold: { fontSize: 36, fontWeight: 700, lineHeight: 42 },
    medium: { fontSize: 36, fontWeight: 500, lineHeight: 42 },
  },
  h2: {
    bold: { fontSize: 28, fontWeight: 700, lineHeight: 34 },
    medium: { fontSize: 28, fontWeight: 500, lineHeight: 34 },
  },
  h3: {
    bold: { fontSize: 24, fontWeight: 700, lineHeight: 34 },
    medium: { fontSize: 24, fontWeight: 500, lineHeight: 34 },
  },
  h4: {
    bold: { fontSize: 20, fontWeight: 700, lineHeight: 26 },
    medium: { fontSize: 20, fontWeight: 500, lineHeight: 26 },
    regular: { fontSize: 20, fontWeight: 400, lineHeight: 26 },
  },
  h5: {
    bold: { fontSize: 18, fontWeight: 700, lineHeight: 26 },
    medium: { fontSize: 18, fontWeight: 500, lineHeight: 26 },
    regular: { fontSize: 18, fontWeight: 400, lineHeight: 26 },
  },
  large: {
    medium: { fontSize: 16, fontWeight: 500, lineHeight: 26 },
    regular: { fontSize: 16, fontWeight: 400, lineHeight: 26 },
  },
  default: {
    regular: { fontSize: 14, fontWeight: 400, lineHeight: 20 },
    medium: { fontSize: 14, fontWeight: 500, lineHeight: 20 },
  },
  small: {
    regular: { fontSize: 12, fontWeight: 400, lineHeight: 18 },
    medium: { fontSize: 12, fontWeight: 500, lineHeight: 18 },
    bold: { fontSize: 12, fontWeight: 700, lineHeight: 18 },
  },
} as const;

export const fontFamily = 'Roboto';
